module.exports = __webpack_public_path__ + "static/lirinode-00d930b90b841d455b427409e51fedb3.jpg";